
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.453 0h21.094v2.813H1.453V0zM1.453 4.219v9.984H5.12c1.283-2.5 3.882-4.219 6.88-4.219 2.998 0 5.597 1.719 6.88 4.22h3.667V4.218H1.453zm18.281 5.765h-4.218V8.578h4.218v1.406zM13.406 16.313a.704.704 0 00-.703-.704h-1.406v1.407h1.406a.704.704 0 00.703-.703zM12.703 18.422h-1.406v1.406h1.406a.704.704 0 000-1.406z","fill":"#838383"}}),_c('path',{attrs:{"d":"M12 11.39a6.335 6.335 0 00-6.328 6.329C5.672 21.209 8.51 24 12 24c3.49 0 6.328-2.792 6.328-6.281A6.335 6.335 0 0012 11.39zm2.813 7.735c0 1.163-.947 2.11-2.11 2.11v1.406h-1.406v-1.407H9.89v-7.03h1.406v-1.407h1.406v1.406c1.163 0 2.11.946 2.11 2.11 0 .54-.205 1.032-.54 1.406a2.1 2.1 0 01.54 1.406z","fill":"#838383"}})])
          )
        }
      }
    